import _ from 'underscore';
import React from 'react';

export const severityTypes = ['Critical', 'Warning', 'Opportunity', 'Information'];

export const SeverityStringsMap = {
  Critical: _TL_('Critical'),
  Warning: _TL_('Warning'),
  Opportunity: _TL_('Recommendations'),
  Information: _TL_('Informational'),
};

export const severityCssClassName = 'notification-severity';
export const alertQueueIconCssClassName = 'alert-queue-icon';

const cssClassFunc = prefix => alertType => `${prefix}-${alertType}`;
const cssClassMapping = (prefix) => {
  const func = cssClassFunc(prefix);

  return {
    Critical: func('critical'),
    Warning: func('warning'),
    Opportunity: func('opportunity'),
    Information: func('info'),
  };
};

export const severityCssClasses = cssClassMapping(severityCssClassName);
export const alertQueueIconCssClasses = cssClassMapping(alertQueueIconCssClassName);

export const NotificationQueueContext = React.createContext({
  logger: {
    mark: _.noop,
    startScenario: _.noop,
    endScenario: _.noop,
    trace: _.noop,
    error: _.noop,
  },
  logContent: _.noop,
  i18n: {
    getString: _.noop,
  },
  isUINext: false,
});

export const withConsumer = Component => (
  props => (
    <NotificationQueueContext.Consumer>
      {value => (<Component {...value} {...props} />)}
    </NotificationQueueContext.Consumer>
  )
);

export const scenarioNames = {
  ViewAll: 'UnifiedNotificationQueueViewAll',
  ActionLink: 'UnifiedNotificationQueueNotificationActionLink',
  CommonDismiss: 'UnifiedNotificationQueueNotificationCommonDismiss',
  NotificationCard: 'UnifiedNotificationQueueNotificationCard',
  NotificationSeverity: 'UnifiedNotificationQueueNotificationSeverity',
};

export const notificationLogKeys = [
  'severity',
  'notificationSource',
  'notificationTypeId',
  'uiDeliveryId',
  'opportunityNotification',
];

export const MessageType = {
  Html: 'Html',
  ReactComponent: 'ReactComponent',
}
